import { useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useAnalytics() {
  const trackPageView = useCallback((page) => {
    axios.post(`${API}/analytics/pageview`, {
      page,
      referrer: document.referrer,
      user_agent: navigator.userAgent,
    }).catch(() => {});
  }, []);

  return { trackPageView };
}

export function usePageTracking() {
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    trackPageView(window.location.pathname);

    // Track section visibility
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            trackPageView(`/#${entry.target.id}`);
          }
        });
      },
      { threshold: 0.5 }
    );

    const sections = document.querySelectorAll('section[id]');
    sections.forEach((s) => observer.observe(s));

    return () => observer.disconnect();
  }, [trackPageView]);
}

// Google Analytics helper
export function initGoogleAnalytics() {
  const gaId = process.env.REACT_APP_GA_ID;
  if (!gaId) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  gtag('js', new Date());
  gtag('config', gaId);
  window.gtag = gtag;
}
